import React, { useContext, useEffect, useState } from 'react'
import { Col, Spinner } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import { useFetch } from '../../hooks'
import ReactPaginate from 'react-paginate'
import { api } from '../../utils/index'
import { StudiKwFilterDataContext } from '../../HOC/studiKwFiltersContext'
import { all, create } from 'mathjs'
import { Button, Card, CardHeader, Row, Table } from 'reactstrap'
import { ToastContainer } from 'react-toastify'
import { notify } from '../../utils/notify'
import Tooltip from 'react-bootstrap/Tooltip'
import { getRankInspectorClientName } from '../StudiKwListing/clienteDisplay'

const StudiKwIndexListing = () => {
	let history = useHistory()
	const itemPerPage = 10

	const [pages, setPages] = useState(0)

	const [tableData, setTableData] = useState([])

	const { data, info, loading, error } = useFetch({
		url: 'studiokw-scheduled/',
		params: { page_size: 10 },
	})

	const math = create(all)

	const [filteredData, setFilteredData, getFilteredData, queryParams, actualPage, setActualPage] =
		useContext(StudiKwFilterDataContext)

	const renderTooltip = props => (
		<Tooltip {...props}>Se premuto rilancia le keyword mancanti in modalità prioritaria</Tooltip>
	);

	const handlePageClick = (data) => {
		let currentPage = data.selected + 1
		setActualPage(currentPage)
		if (Object.keys(filteredData).length > 0) {
			getFilteredData({
				...queryParams,
				// execute_priority: true,
				page_size: 10,
				page: currentPage,
			})
		} else {
			setFilteredData({})
			api
				.get('studiokw-scheduled/', {
					params: {
						// execute_priority: true,
						page_size: 10,
						page: currentPage,
					},
				})
				.then((response) => {
					setTableData(response.data.results)
					setPages(Math.ceil(response.data.count / itemPerPage))
				})
				.catch((error) => console.error(error))
		}
	}

	const icon = <i className="fa-solid fa-plus"></i>

	const handleStatus = (id, status) => {
		api
			.patch(`studiokw-scheduled/${id}` + '/', {status: status}, {
			})
			.then(() => {
				setTableData(
					getFilteredData({
					...queryParams,
					page_size: 10,
					page: actualPage,
				}))
			})
			.catch((error) => console.error(error))
	}

	useEffect(() => {
		if (data.length > 0 && tableData.length === 0) {
			setTableData(data)
			setPages(Math.ceil(info.count / itemPerPage))
		}
	}, [data])

	useEffect(() => {
		if (filteredData.results) {
			setTableData(filteredData.results)
			setPages(Math.ceil(filteredData.count / itemPerPage))
		}
	}, [tableData, filteredData])

	const buttonPressed = async e => {
		let id = e.target.id
		await api
			.get(`priority/${id}`, {
				params: {
					id: id,
				},
			})
			.then(() => {
				notify(
					"Richiesta in priorità inviata.",
					'success'
				  )
				window.location.reload()
			})
				.catch((error) => {
					notify(
						error.response.data,
						'error'
					)
				})
	}

	return (
		<>
			{loading && <Spinner animation="grow" />}{' '}
			{tableData && (
				<Row style={{marginBottom: "100px"}}>
				<div className="col pb-5">
					<Card className="shadow">
						<CardHeader className="border-0">
						<Row style={{ marginLeft: "0px" }}>
							<Col md={10}>
								<h1 className="mb-0">Studi Keywords Indice Consistenza</h1>
							</Col>
							<Col md={2} style={{textAlign: "right"}}>
								<Button style={{marginRight: "55px"}} color="info" onClick={() => history.push('/add-scheduling-index')} icon={icon}>+ Add new</Button>
							</Col>
						</Row>
						</CardHeader>
							<Table className="align-items-center table-flush" responsive>
								<>
								<thead className="thead-light">
									<tr>
										<th scope="col" style={{fontSize: "12px"}}>Name</th>
										<th scope="col" style={{fontSize: "12px"}}>Files</th>
										<th scope="col" style={{fontSize: "12px"}}>Next Run</th>
										<th scope="col" style={{fontSize: "12px"}}>Mobile</th>
										<th scope="col" style={{fontSize: "12px"}}>Country</th>
										<th scope="col" style={{fontSize: "12px"}}>Cliente</th>
										<th scope="col" style={{fontSize: "12px"}}>N°KW</th>
										<th scope="col" style={{fontSize: "12px"}}>Monthly Cost</th>
										<th scope="col" />
									</tr>
								</thead>
									<tbody>
										{tableData.map((item) => (
											<tr key={item.id}>
												<td>
													<Link to={`/add-scheduling-index/${item.id}`}>{item.nome}</Link>
												</td>
												<td>
													<Link to={`/scheduling_index_list/${item.id}`}>{item.related_studiokw_number}</Link>
												</td>
												<td>{item.next_run.split('T')[0]}</td>
												<td>{item.mobile + ''}</td>
												<td>{item.country}</td>
												<td>{getRankInspectorClientName(item)}</td>
												<td>{item.kw_number}</td>
												<td>{item.cost_min_month}</td>
												<td className="d-flex flex-column">
													<div>
														Stato:{' '}
														{item.status === 'disabled' ? (
															<span style={{ color: 'red' }}>
																<i className="fa-solid fa-circle-xmark fa-xs"></i>
															</span>
														) : (
															<span style={{ color: 'green' }}>
																<i className="fa-solid fa-circle-check fa-xs"></i>
															</span>
														)}
													</div>
													<Button
														className="btn-sm"
														variant="link"
														onClick={() =>
															handleStatus(
																item.id,
																item.status === 'disabled' ? 'enabled' : 'disabled'
															)
														}
													>
														{item.status === 'disabled' ? 'Abilita' : 'Disabilita'}
													</Button>
												</td>
											</tr>
										))}
									</tbody>
								</>
							</Table>
							<ReactPaginate 
								previousLabel={'<'}
								nextLabel={'>'}
								breakLabel={'...'}
								pageCount={pages}
								forcePage={actualPage - 1}
								onPageChange={handlePageClick}
								containerClassName={'pagination justify-content-center pt-5 pb-3'} // classname of the pagination container (ul)
								pageClassName={'page-item'} // classname on tag li of each page element
								pageLinkClassName={'page-link'} // classname on tag a of each page element
								previousClassName={'page-item'}
								previousLinkClassName={'page-link'}
								nextClassName={'page-item'}
								nextLinkClassName={'page-link'}
								breakClassName={'page-item'}
								breakLinkClassName={'page-link'}
								activeClassName={'active'}
							/>
							</Card>
					</div>
				</Row>
			)}
			<ToastContainer />
		</>
	)
}

export default StudiKwIndexListing
